<template>
    <div class="modal fade fill-in" id="exportModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header clearfix text-left">
                    <h4>Transformer en client SAP</h4>
                </div>
                <div class="modal-body">
                    <p>Les clients exportés manuellement vers SAP doivent répondre à l'un des critères suivants :</p>
                    <dl>
                        <dt>Forme juridique</dt>
                        <dd>Association à but humanitaire</dd>
                        <dt>Modalités de règlement</dt>
                        <dd>Montant différent de celui indiqué dans le tunnel d'achat ou modes de règlement multiples</dd>
                    </dl>
                    <p>Etes vous certain de vouloir exporter ce client vers SAP ?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" @click="$emit('confirm')"
                            class="btn btn-primary btn-cons pull-left inline" data-dismiss="modal">
                        Oui

                    </button>
                    <button type="button" class="btn btn-default btn-cons no-margin pull-left inline"
                            data-dismiss="modal" @click="$emit('cancel')">Non
                    </button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        mounted () {
            $(this.$el).modal()
        },

        beforeDestroy () {
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },
    }
</script>

<style lang="scss" scoped>
  dt { margin-top: 10px; }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/ExportModal.vue